import { Injectable, inject } from "@angular/core";
import { UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { getCurrentUser } from "aws-amplify/auth";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  private router = inject(Router);

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return getCurrentUser()
      .then(() => true)
      .catch(() => {
        this.router.navigate(["login"]);
        return false;
      });
  }
}
